import { Controller } from "stimulus"
import { EventTrackerService } from "../services/event_tracker_service"

export default class extends Controller {
  connect() {
    this.eventTracker = new EventTrackerService();
    this.eventTracker.initialize();
  }

  track(e) {
    const eventName = e.currentTarget.dataset.eventName;
    const eventProperties = e.currentTarget.dataset.eventProperties;

    this.eventTracker.trackEvent(eventName, eventProperties, e.currentTarget);
  }
}
